import * as echarts from "echarts"
import EChartsController from "../echarts_controller"
import { world, countries } from "../world_topology"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
  }

  initialize() {
    echarts.registerMap("world", world)
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const validCountries = countries.filter((country) => country.code != null)
    const validCountryCodes = new Set(
      validCountries.map((country) => country.code.toLowerCase()),
    )
    const validThreats = this.dataValue.filter((threat) =>
      validCountryCodes.has(threat.source_country_code),
    )
    const threats = validThreats.map((threat) => {
      const { name: source_country_name } = validCountries.find(
        (country) => country.code.toLowerCase() === threat.source_country_code,
      )

      return {
        ...threat,
        source_country_name,
      }
    })

    this.renderChart(this.chart, threats)
  }

  renderChart(chart, threats) {
    chart.setOption({
      geo: {
        type: "map",
        map: "world",
        regions: threats.map(({ source_country_name }) => ({
          name: source_country_name,
          itemStyle: {
            areaColor: "#627C8580",
          },
        })),
        itemStyle: {
          areaColor: "#627C8514",
          borderColor: "#3B484C",
          borderWidth: 0.5,
        },
        emphasis: {
          label: {
            show: false,
          },
          itemStyle: {
            areaColor: "#627C8580",
            opacity: 0.6,
          },
        },
        select: false,
      },
    })

    const getOption = (geo) => {
      const threatsWithCoord = threats.map((threat) => {
        const center =
          geo.getRegion(threat.source_country_name)?.getCenter() || []

        return {
          ...threat,
          coord: [center[0], center[1]],
        }
      })

      return {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "Threats",
            type: "map",
            geoIndex: 0,
            data: threats.map(({ source_country_name, events_count }) => {
              return {
                name: source_country_name,
                value: events_count,
              }
            }),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            silent: true,
            rippleEffect: {
              period: 4,
              scale: 6,
              number: 1,
              brushType: "stroke",
            },
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#F05252",
              borderWidth: 0,
            },
            data: threatsWithCoord.map(({ coord }) => ({
              value: coord,
            })),
          },
          {
            name: "Threats",
            type: "scatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            silent: true,
            markPoint: {
              symbol: "circle",
              symbolSize: 10,
              label: {
                show: false,
              },
              itemStyle: {
                color: "transparent",
                borderColor: "#E64E1C",
                borderWidth: 2,
              },
              data: threatsWithCoord.map(({ coord }) => ({
                coord,
              })),
            },
            label: {
              show: false,
            },
          },
        ],
      }
    }

    const mapOption = getOption(
      chart.getModel().getComponent("geo").coordinateSystem,
    )
    chart.setOption(mapOption)
  }
}
